"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputSelectBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_input_behavior_1 = require("../../atoms/bc-input/bc-input-behavior");
var bc_abstract_dropdown_behavior_1 = require("../bc-dropdown/bc-abstract-dropdown-behavior");
var input_constants_1 = require("../input/input-constants");
var bc_input_select_constants_1 = require("./bc-input-select-constants");
var bc_input_select_constants_2 = require("./bc-input-select-constants");
var bc_input_select_constants_3 = require("./bc-input-select-constants");
var bc_input_select_constants_4 = require("./bc-input-select-constants");
var bc_input_select_constants_5 = require("./bc-input-select-constants");
var bc_input_select_constants_6 = require("./bc-input-select-constants");
var bc_input_select_constants_7 = require("./bc-input-select-constants");
var BcInputSelectBehavior = (function (_super) {
    __extends(BcInputSelectBehavior, _super);
    function BcInputSelectBehavior() {
        var _this = _super.call(this) || this;
        _this.activeElements = {};
        _this.selectedItemsDisplay = '{0} ítems seleccionados';
        _this.bcInputBehavior = new bc_input_behavior_1.BcInputBehavior();
        _this.isDisabled = false;
        _this.isKeydown = false;
        _this.inpValue = '';
        return _this;
    }
    BcInputSelectBehavior.prototype._setUp = function () {
        this.addPaddingRightWhenIcon();
        this.isMultiple = this.mySelf.hasAttribute('multiple');
        this.isFilter = this.mySelf.hasAttribute('filter');
        var input = this.mySelf.querySelector('input');
        input.readOnly = this._setReadOnly(this.isFilter, input);
        this.setDropDownConfiguration();
        _super.prototype._setUp.call(this);
        this.bcInputBehavior.setElement(input);
        this.bcInputBehavior.setUp();
        this.createItems();
        this.getInsideElements();
        this.setMarginTop();
        this.setEventListeners();
        this.markItemByIndex(this.defaultIndex);
        this.toggleFocus();
        this.initAccesibilityInput();
        this.closeEsc();
        this.focusFirstLastItem();
        this.itemsArrow();
    };
    BcInputSelectBehavior.prototype._setReadOnly = function (typeInput, input) {
        if (typeInput) {
            this.filter(input);
            return false;
        }
        return true;
    };
    BcInputSelectBehavior.prototype.createItems = function () {
        this.closeDropdown();
        var mySelf = this.mySelf.querySelector("*[id='".concat(this.idContent, "']"));
        for (var _i = 0, _a = Array.from(mySelf.childNodes); _i < _a.length; _i++) {
            var i = _a[_i];
            mySelf.removeChild(i);
        }
        this.activeElements = {};
        this.dropdownItems = [];
        if (this.itemsConfig) {
            for (var _b = 0, _c = this.itemsConfig; _b < _c.length; _b++) {
                var itemObj = _c[_b];
                var index = this.itemsConfig.indexOf(itemObj);
                if (typeof itemObj != 'object') {
                    this.itemsConfig[index] = { label: itemObj, value: itemObj, aux: itemObj };
                }
                var li = null;
                this.itemsConfigAux = this.itemsConfig;
                if (this.isMultiple) {
                    li = this.createItemTypeMultiple(this.itemsConfig[index]);
                }
                else if (this.isFilter) {
                    li = this.createItemTypeSingle(this.itemsConfig[index]);
                    (0, helpers_1.addFocusable)(li, { tabindex: '0' });
                }
                else {
                    li = this.createItemTypeSingle(this.itemsConfig[index]);
                }
                (0, helpers_1.addFocusable)(li, { tabindex: '0' });
                this.dropdownItems.push(li);
                this.dropdownContent.appendChild(li);
            }
        }
        this.setValueInputMultiple();
    };
    BcInputSelectBehavior.prototype.createItemTypeSingle = function (data) {
        var li = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
        li.classList.add(this.config.itemClass);
        if (data.icon) {
            var em = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
            em.innerText = data.icon;
            li.appendChild(em);
        }
        var spanTag = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanTag.innerHTML = data.label;
        spanTag.classList.add(bc_input_select_constants_1.INPUT_SPAN_SINGLE);
        li.appendChild(spanTag);
        return li;
    };
    BcInputSelectBehavior.prototype.createItemTypeMultiple = function (data) {
        var li = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
        li.classList.add(this.config.itemClass);
        var labelTag = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        var inputTag = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        var spanTag = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        labelTag.classList.add(common_constants_1.BcCommonConstants.CONTAINER_CHECKBOX_CLASS);
        spanTag.classList.add(common_constants_1.BcCommonConstants.CHECKBOX_CLASS);
        inputTag.setAttribute('type', 'checkbox');
        inputTag.setAttribute('class', bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS);
        labelTag.innerText = data.label;
        labelTag.appendChild(inputTag);
        labelTag.appendChild(spanTag);
        li.appendChild(labelTag);
        li.appendChild(labelTag);
        return li;
    };
    BcInputSelectBehavior.prototype.setItems = function (items) {
        this.itemsConfig = items;
        this.itemsConfigAux = items;
        this.updateDropdown();
    };
    BcInputSelectBehavior.prototype.setMarginTop = function () {
        if (this.span) {
            this.topMarginContent = common_constants_1.COMMON_CONSTANTS_NUMBERS.Negative25;
        }
    };
    BcInputSelectBehavior.prototype.setSelectedItemsDisplay = function (displayInfo) {
        if (displayInfo) {
            this.selectedItemsDisplay = displayInfo;
        }
    };
    BcInputSelectBehavior.prototype.setDefaultIndex = function (index) {
        this.defaultIndex = index;
    };
    BcInputSelectBehavior.prototype.setDefaultValue = function (value) {
        var index = 0;
        if (value) {
            for (var elementIndex in this.itemsConfig) {
                var itemConfigIndex = this.itemsConfig[elementIndex];
                var stringCondition = typeof itemConfigIndex === 'string' && itemConfigIndex === value;
                var objectCondition = typeof itemConfigIndex === 'object' &&
                    (itemConfigIndex['value'] === value || itemConfigIndex['label'] === value);
                if (stringCondition || objectCondition) {
                    break;
                }
                index++;
            }
            this.markItemByIndex(index);
            if (index >= 0 && index < this.itemsConfig.length) {
                this.defaultIndex = index;
            }
        }
    };
    BcInputSelectBehavior.prototype.getInsideElements = function () {
        this.input = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class*=").concat(input_constants_1.INPUT, "]"));
        this.span = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class=").concat(input_constants_1.INPUT, "] ~ ").concat(common_constants_1.BcCommonConstants.SPAN_TAG));
        if (!this.itemsConfig) {
            this.getItems();
        }
    };
    BcInputSelectBehavior.prototype.getItems = function () {
        var items = Array.from(this.mySelf.querySelectorAll("*[class=".concat(bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS, "]")));
        this.itemsConfig = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            this.dropdownItems.push(item);
            var span = item.querySelector("".concat(common_constants_1.BcCommonConstants.SPAN_TAG));
            this.itemsConfig.push({ label: span.innerText, value: span.innerText });
        }
    };
    BcInputSelectBehavior.prototype.setDropDownConfiguration = function () {
        this.setConfig({
            toggleClass: bc_input_select_constants_7.INPUT_SELECT_TOGGLE_CLASS,
            toggleActiveClass: bc_input_select_constants_3.INPUT_SELECT_ACTIVE_TOGGLE_CLASS,
            contentClass: bc_input_select_constants_5.INPUT_SELECT_CONTENT_CLASS,
            contentActiveClass: bc_input_select_constants_2.INPUT_SELECT_ACTIVE_CONTENT_CLASS,
            itemClass: bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS,
            triangleClass: bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS,
            extraToggles: [
                {
                    node: this.input,
                    events: ['focus'],
                },
            ],
            toggleEvents: ['click', 'input'],
            mainClass: bc_input_select_constants_4.INPUT_SELECT_CLASS,
            mainActiveClass: bc_input_select_constants_1.INPUT_SELECT_ACTIVE_CLASS,
            static: false,
            isPopUp: false,
            isDisabled: this.isDisabled,
            parentWidth: true,
            multiple: this.isMultiple,
            maxHeightContent: this.maxHeightContent,
        });
    };
    BcInputSelectBehavior.prototype.setDisabled = function (isDisabled) {
        this.isDisabled = isDisabled;
        this.disabled = isDisabled;
        this.setDropDownConfiguration();
        if (this.validateDropdownIsActive() && this.isDisabled) {
            this.closeDropdown();
        }
    };
    BcInputSelectBehavior.prototype.getCurrentActiveItems = function () {
        var response = [];
        if (this.itemsConfig) {
            for (var key in this.activeElements) {
                if (Object.prototype.hasOwnProperty.call(this.activeElements, key) && parseInt(key) < this.itemsConfig.length) {
                    if (this.formatType === 'full') {
                        response.push(this.itemsConfig[parseInt(key)]);
                    }
                    else {
                        response.push(this.itemsConfig[parseInt(key)].value);
                    }
                }
            }
            if (!this.isMultiple && response.length > 0) {
                response = response[0];
            }
        }
        return response;
    };
    BcInputSelectBehavior.prototype.setFormatOutput = function (formatType) {
        if (formatType && (formatType === 'simple' || formatType === 'full')) {
            this.formatType = formatType;
        }
    };
    BcInputSelectBehavior.prototype.createActiveIcon = function () {
        var check = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        check.innerText = 'ok';
        check.id = 'icon-check';
        return check;
    };
    BcInputSelectBehavior.prototype.deleteActiveIcon = function () {
        var _this = this;
        var BASE_10 = 10;
        this.dropdownItems.forEach(function (itemDropdown, i) {
            var checkElement = itemDropdown.querySelector("".concat(common_constants_1.BcCommonConstants.EM_TAG));
            var checkBoxElement = itemDropdown.querySelector("[class~='".concat(common_constants_1.BcCommonConstants.CONTAINER_CHECKBOX_CLASS, "'] .").concat(common_constants_1.BcCommonConstants.CHECKBOX_CLASS));
            if (checkElement && checkElement.innerHTML == 'ok') {
                itemDropdown.removeChild(checkElement);
            }
            if (checkBoxElement) {
                for (var property in _this.activeElements) {
                    _this.markItemByIndex(parseInt(property, BASE_10));
                }
            }
        });
    };
    BcInputSelectBehavior.prototype.markItemByIndex = function (index) {
        if (index !== undefined && this.dropdownItems.length > index && index >= 0) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            this.dropdownItems[String(index)].dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK, {}));
        }
    };
    BcInputSelectBehavior.prototype.configSelectedEvent = function (event, i, item) {
        if (this.isMultiple) {
            if (['INPUT', 'LI'].indexOf(event.target.tagName) === -1) {
                event.stopPropagation();
                return;
            }
            var inputInside = item.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            var condition = i in this.activeElements;
            if (inputInside) {
                this.configInputCheck(inputInside, condition, event, item, i);
            }
            this.setValueInputMultiple();
        }
        else {
            this.dropdownItems.forEach(function (itemDropdown) {
                var checkElement = itemDropdown.querySelector("".concat(common_constants_1.BcCommonConstants.EM_TAG, "[id=\"icon-check\"]"));
                if (checkElement) {
                    itemDropdown.removeChild(checkElement);
                }
            });
            this.activeElements = {};
            var check = this.createActiveIcon();
            if (event.target.tagName == 'LI') {
                event.target.appendChild(check);
            }
            else {
                event.target.parentNode.appendChild(check);
            }
            this.activeElements[i] = { item: event.target, check: check };
            this.closeDropdown();
            this.setValueInputSingle();
        }
        if (this.outputFunction) {
            this.outputFunction(this.getCurrentActiveItems());
        }
    };
    BcInputSelectBehavior.prototype.configInputCheck = function (inputInside, condition, event, item, i) {
        if (event.target.tagName === 'LI') {
            event.stopPropagation();
            inputInside.click();
            return;
        }
        if (!condition) {
            inputInside.setAttribute('checked', '' + condition);
            this.activeElements[i] = {
                item: item,
                check: null,
            };
        }
        else {
            inputInside.removeAttribute('checked');
            delete this.activeElements[i];
        }
    };
    BcInputSelectBehavior.prototype.setEventListeners = function () {
        var _this = this;
        var addEvent = function (item) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                _this.inpValue = '';
                var dropdownItemsString = _this.dropdownItems.map(function (x) { return x.innerHTML; });
                _this.configSelectedEvent(event, dropdownItemsString.indexOf(item.innerHTML), item);
                if (_this.isKeydown === true) {
                    _this.itemsConfig = _this.itemsConfigAux;
                    _this.updateDropdown();
                    _this.isKeydown = false;
                }
            });
        };
        this.openDropdownClickInput(this.input);
        for (var _i = 0, _a = this.dropdownItems; _i < _a.length; _i++) {
            var item = _a[_i];
            addEvent(item);
        }
    };
    BcInputSelectBehavior.prototype.setValueInputMultiple = function () {
        var text = null;
        var keys = Object.keys(this.activeElements);
        if (keys.length > 1) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            text = this.selectedItemsDisplay.replace('{0}', String(keys.length));
        }
        else if (keys.length == 1) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            text = this.getValueInputSingle(parseInt(keys[0]));
        }
        else {
            this.bcInputBehavior.addRemoveClass(false, this.mySelf.querySelector('input'));
            text = '';
        }
        if (this.input) {
            this.input.value = text;
        }
    };
    BcInputSelectBehavior.prototype.setValueInputSingle = function (indexItem) {
        var text = this.getValueInputSingle(indexItem);
        if (this.input) {
            this.input.value = text;
        }
        this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
        return text;
    };
    BcInputSelectBehavior.prototype.getValueInputSingle = function (indexItem) {
        var index = 0;
        var item = null;
        if (indexItem) {
            index = indexItem;
            item = this.activeElements[String(index)];
        }
        else {
            for (var key in this.activeElements) {
                if (Object.prototype.hasOwnProperty.call(this.activeElements, key)) {
                    index = parseInt(key);
                    item = this.activeElements[key];
                }
            }
        }
        var text = '';
        if (this.config) {
            text = this.itemsConfig[index].label;
        }
        else {
            if (item) {
                var spanLabel = item.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
                var textLabel = spanLabel.innerText;
                text = textLabel;
            }
        }
        return text;
    };
    BcInputSelectBehavior.prototype.filter = function (input) {
        var _this = this;
        this.inpValue = '';
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function (event) {
            var key = event.target.value;
            _this.inpValue = key;
            _this.handleInput(key);
        });
        this.openDropdownClickInput(input);
    };
    BcInputSelectBehavior.prototype.handleInput = function (inputValue) {
        var _this = this;
        var selectArray = [];
        if (inputValue) {
            selectArray = this.itemsConfigAux.filter(function (x) {
                return x.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
            });
            selectArray.forEach(function (text) {
                text.aux = text.label;
                if (!_this.isMultiple) {
                    text.label = text.label.replace(new RegExp("(".concat(_this.inpValue, ")"), 'i'), '<strong>$1</strong>');
                }
            });
            this.itemsConfig = selectArray;
            this.updateDropdown();
            this.openDrowndown();
        }
        else {
            selectArray = [];
            this.cleanSearchBehavior();
        }
    };
    ;
    BcInputSelectBehavior.prototype.addItemSelectArray = function (itemsConfigAux, selectArray, inpValue) {
        var _this = this;
        itemsConfigAux.forEach(function (item) {
            var itemLabel = item.label.toLowerCase();
            if (itemLabel.includes(inpValue)) {
                selectArray.push(item);
                _this.itemsConfig = selectArray;
                selectArray = _this.removeItemSelectArray(selectArray, inpValue);
                _this.updateDropdown();
                _this.openDrowndown();
            }
        });
        return selectArray;
    };
    BcInputSelectBehavior.prototype.removeItemSelectArray = function (selectArray, inpValue) {
        selectArray.find(function (element, index) {
            if (element) {
                var elementLabel = element.label.toLowerCase();
                if (!elementLabel.includes(inpValue)) {
                    selectArray.splice(index, 1);
                }
            }
        });
        if (selectArray.length > 0) {
            selectArray.reduce(function (unique, item, index) {
                if (item.label === unique.label) {
                    selectArray.splice(index, 1);
                }
            });
        }
        return selectArray;
    };
    BcInputSelectBehavior.prototype.updateDropdown = function () {
        this.closeDropdown();
        var mySelf = this.mySelf.querySelector("*[id='".concat(this.idContent, "']"));
        if (!mySelf) {
            return;
        }
        for (var _i = 0, _a = Array.from(mySelf.childNodes); _i < _a.length; _i++) {
            var i = _a[_i];
            mySelf.removeChild(i);
        }
        this.activeElements = {};
        this.dropdownItems = [];
        if (this.itemsConfig) {
            for (var _b = 0, _c = this.itemsConfig; _b < _c.length; _b++) {
                var itemObj = _c[_b];
                var index = this.itemsConfig.indexOf(itemObj);
                if (typeof itemObj != 'object') {
                    this.itemsConfig[index] = { label: itemObj, value: itemObj };
                }
                else {
                    this.itemsConfig[index] = itemObj;
                }
                this.createDropdownItem(index);
            }
        }
        this.setEventListeners();
    };
    BcInputSelectBehavior.prototype.createDropdownItem = function (index) {
        var li = null;
        if (this.isFilter) {
            if (this.isMultiple) {
                li = this.createItemTypeMultiple(this.itemsConfig[index]);
            }
            else {
                li = this.createItemTypeSingle(this.itemsConfig[index]);
            }
            this.itemsConfig[index].label = this.itemsConfig[index].aux
                ? this.itemsConfig[index].aux
                : this.itemsConfig[index].label;
        }
        if (!li) {
            return;
        }
        li.setAttribute('tabIndex', '0');
        this.dropdownItems = this.dropdownItems.concat(li);
        this.dropdownContent.appendChild(li);
    };
    BcInputSelectBehavior.prototype.setInputValue = function (value) {
        if (!this.mySelf) {
            return;
        }
        var empyString = value ? value : '';
        this.mySelf.querySelector('input').value = empyString;
    };
    BcInputSelectBehavior.prototype.addPaddingRightWhenIcon = function () {
        var input = this.mySelf.querySelector('input');
        input.nextElementSibling.nextElementSibling.classList.add(bc_input_select_constants_1.LABEL_ELIPSIS);
    };
    BcInputSelectBehavior.prototype.openDropdownKeyboard = function (element) {
        var _this = this;
        element.addEventListener('keyup', function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER_NUM ||
                event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE_NUM) {
                _this.openDrowndown();
            }
        });
    };
    BcInputSelectBehavior.prototype.openDropdownClickInput = function (input) {
        var _this = this;
        input.addEventListener('click', function () {
            setTimeout(function () {
                _this.openDrowndown();
            }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N10);
        });
    };
    BcInputSelectBehavior.prototype.toggleFocus = function () {
        var _this = this;
        var toggle = document.querySelectorAll(".".concat(bc_input_select_constants_7.INPUT_SELECT_TOGGLE_CLASS));
        toggle.forEach(function (element) {
            (0, helpers_1.addFocusable)(element, { tabindex: '0' });
            _this.openDropdownKeyboard(element);
        });
    };
    BcInputSelectBehavior.prototype.initAccesibilityInput = function () {
        var _this = this;
        document
            .querySelectorAll("input.".concat(bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS))
            .forEach(function (element) { return element.setAttribute('tabindex', '-1'); });
        document.querySelectorAll('span.bc-checkbox').forEach(function (element) {
            (0, helpers_1.addFocusable)(element, { tabindex: '0' });
            _this.addClickEvent(element, element.previousSibling);
        });
        document.querySelectorAll("li.".concat(bc_input_select_constants_6.INPUT_SELECT_ITEM_CLASS)).forEach(function (element) {
            (0, helpers_1.addFocusable)(element, { tabindex: '0' });
            _this.addClickEvent(element, element);
        });
    };
    BcInputSelectBehavior.prototype.addClickEvent = function (element, clickeableElement) {
        element.addEventListener('keydown', function (event) {
            if (event.code == common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event.key == common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                event.preventDefault();
                event.stopPropagation();
                clickeableElement.click();
            }
        });
    };
    BcInputSelectBehavior.prototype.closeEsc = function () {
        var _this = this;
        var input = this.mySelf.querySelector('input');
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.inpValue = '';
                input.value = '';
                input.dispatchEvent(new KeyboardEvent(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, { key: '' }));
                _this.closeDropdown();
            }
        });
    };
    BcInputSelectBehavior.prototype.focusFirstLastItem = function () {
        var _this = this;
        var firstItem = this.dropdownItems[0];
        var lastItem = this.dropdownItems[this.dropdownItems.length - 1];
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.openDrowndown();
                setTimeout(function () {
                    lastItem.focus();
                }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N100);
            }
            else if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
                _this.openDrowndown();
                setTimeout(function () {
                    firstItem.focus();
                }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N100);
            }
        });
    };
    BcInputSelectBehavior.prototype.itemsArrow = function () {
        var _this = this;
        var firstItem = this.dropdownItems[0];
        var lastItem = this.dropdownItems[this.dropdownItems.length - 1];
        this.dropdownItems.forEach(function (element, index) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                    if (index == _this.dropdownItems.length - 1) {
                        firstItem.focus();
                    }
                    else {
                        element.nextElementSibling.focus();
                    }
                }
                else if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    if (index == 0) {
                        lastItem.focus();
                    }
                    else {
                        element.previousElementSibling.focus();
                    }
                }
            });
        });
    };
    BcInputSelectBehavior.prototype.cleanSearchBehavior = function () {
        this.itemsConfig = this.itemsConfigAux;
        this.updateDropdown();
    };
    return BcInputSelectBehavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcInputSelectBehavior = BcInputSelectBehavior;
